var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "currentColor",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 4.125C10.337 4.125 4.125 10.337 4.125 18S10.337 31.875 18 31.875 31.875 25.663 31.875 18 25.663 4.125 18 4.125ZM1.875 18C1.875 9.094 9.095 1.875 18 1.875c8.906 0 16.125 7.22 16.125 16.125 0 8.906-7.22 16.125-16.125 16.125-8.906 0-16.125-7.22-16.125-16.125ZM18 8.625c.621 0 1.125.504 1.125 1.125v1.125h.375A4.125 4.125 0 0 1 23.625 15a1.125 1.125 0 0 1-2.25 0c0-1.036-.84-1.875-1.875-1.875h-.375v4.064l1.943.648a3.74 3.74 0 0 1-1.183 7.288h-.76v1.125a1.125 1.125 0 0 1-2.25 0v-1.125H16.5A4.125 4.125 0 0 1 12.375 21a1.125 1.125 0 0 1 2.25 0c0 1.035.84 1.875 1.875 1.875h.375v-4.064l-1.943-.648a3.74 3.74 0 0 1 1.183-7.288h.76V9.75c0-.621.504-1.125 1.125-1.125Zm-1.125 4.5h-.76a1.49 1.49 0 0 0-.471 2.904l1.231.41v-3.314Zm2.25 6.436v3.314h.76a1.49 1.49 0 0 0 .471-2.904l-1.231-.41Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.2ce4405c3b56934ec8395c45eee1f937.svg";
export { ForwardRef as ReactComponent };